<template>
  <div>
    <el-dropdown trigger="click" v-show="permission && permission.edit" @visible-change="loadList()">
      <el-button type="primary" size="small">
        <font-awesome-icon :icon="['far', 'list']" style="margin-right:5px" />リストに追加
        <font-awesome-icon icon="caret-down" style="margin-left:5px" />
      </el-button>
      <el-dropdown-menu slot="dropdown" class="list-select">
        <div class="dropdown-search">
          <el-input class="dropdown-input" placeholder="リストを検索" prefix-icon="el-icon-search" size="large" clearable v-model="search_word" @input="loadList()"></el-input>
        </div>
        <el-dropdown-item class="add-list-dropdown" @click.native="openConfirmModal(list.list_id, list.list_name)" v-for="list in list" :key="list.id" v-show="list.list_id != list_id">
          <div class="flex-row">            
            <svg v-if="list.sns_type === 'twitter'" style="margin-right:5px" width="9" height="9" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="currentColor"/>
            </svg>
            <font-awesome-icon v-else :icon="['fab', list.sns_type]" style="margin-right:5px" />            
            <div class="dropdown_listname">{{ list.list_name }}</div>
            <div class="flex-space"></div>
            <span>{{ list.influencer_num }}</span>
          </div>
        </el-dropdown-item>
        <div v-show="result_count == 0 && !loading" class="add-list-dropdown-nolist">リストがありません</div>
        <infinite-loading spinner="spiral" :identifier="infiniteId" @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results" style="font-size:40px;"></div>
        </infinite-loading>
        <el-dropdown-item class="new-list" icon="el-icon-plus" @click.native="create_list = true" :disabled="activate == 12 && active_list_count >= 10" divided>新規リスト作成</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-button type="primary" size="small" v-show="permission && !permission.edit" @click="openUnpermitted()">
      <font-awesome-icon :icon="['far', 'list']" style="margin-right:5px" />リストに追加
      <font-awesome-icon icon="caret-down" style="margin-left:5px" />
    </el-button>

    <createList
      :type="'add'"
      :sns_type="sns_type"
      :create_list.sync="create_list"
      :add_comment.sync="add_comment"
      :from_media_search="from_media_search"
      :other_sns_type="other_sns_type"
      @loadList="loadList"
      @addInfluencer="addInfluencer"
    />

    <transition name="fade">
      <div class="phrase-overlay" v-if="confirm" @click.self="confirm = false">
        <div class="create-phrase-wrap w-480">
          <div class="list-create">
            <div class="newmessage-title">
              インフルエンサーを追加
              <div class="flex-space"></div>
              <div class="newmessage-button" @click="confirm = false">
                <font-awesome-icon :icon="['fal', 'times']" />
              </div>
            </div>
            <div class="list-create-message">
              <div><font-awesome-icon :icon="['fas', 'exclamation-circle']" style="color:#888; font-size:24px" /></div>
              <div v-if="from_media_search">{{ checkList.length }}件の投稿インフルエンサーを{{ target_list_name }}に追加しますか？</div>
              <div v-else>{{ checkList.length }}名のインフルエンサーを「{{ target_list_name }}」に追加しますか？</div>
            </div>
            <div class="list-create-footer">
              <div class="flex-row" v-if="from_media_search">
                <el-checkbox class="checkbox-show checkbox-small" v-model="add_comment">
                  投稿URLをリスト内コメントに追加する
                </el-checkbox>
              </div>
              <div class="flex-space"></div>
              <el-button @click="confirm = false">キャンセル</el-button>
              <el-button
                id="ok-button"
                type="primary"
                :disabled="add_loading"
                @click="addInfluencer(target_list_id, target_list_name)"
                @keydown.enter="addInfluencer(target_list_id, target_list_name)"
                @keydown.esc="confirm = false"
              >
                <div class="flex-row">
                  OK
                  <div class="loader--mini" v-show="add_loading"></div>
                </div>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadListAPI = root + "/api/list/load_list";
const addInfluencerAPI = root + "/api/list/add_influencer";
import createList from "./createList";

export default {
  name: "addListButton",
  props: ["checkList", "checkAll_val", "sns_type", "list_id", "from_media_search", "other_sns_type"],
  components: {
    createList,
  },
  data() {
    return {
      list: [],
      result_count: 0,
      active_list_count: "",
      search_word: "",
      create_list: false,
      offset: 0,
      infiniteId: +new Date(),
      requestId: +new Date() + 10000,
      loading: false,
      confirm: false,
      add_loading: false,
      add_comment: false,
      target_list_id: "",
      target_list_name: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    permission() {
      return this.$store.state.permission.list;
    },
    activate() {
      return this.$store.state.activate;
    },
  },
  mounted() {
    this.addKeyDown();
  },
  methods: {
    infiniteHandler($state) {
      if (this.permission && this.permission.edit) {
        this.loading = true;
        this.axios.cancel(this.requestId);
        this.requestId += 1;
        this.axios
          .get(loadListAPI, {
            requestId: this.requestId,
            params: {
              token: this.token,
              type: "min",
              offset: this.offset,
              search_word: this.search_word,
              sns_type: this.sns_type,
              other_sns_type: this.other_sns_type
            },
          })
          .then((response) => {
            if (this.offset == 0) {
              this.list = response.data.mylist;
              this.result_count = response.data.result_count;
              this.active_list_count = response.data.active_list_count;
            } else {
              this.list = this.list.concat(response.data.mylist);
            }
            $state.loaded();
            if (this.result_count <= this.offset) $state.complete();
            this.offset += 40;
            this.loading = false;
          });
      }
    },
    loadList() {
      this.list = [];
      this.offset = 0;
      this.result_count = 0;
      this.infiniteId += 1;
    },
    openConfirmModal(list_id, list_name) {
      this.target_list_id = list_id;
      this.target_list_name = list_name;
      this.confirm = true;
      setTimeout(() => {
        this.focusOK();
      }, 200);
    },
    addInfluencer(id, name) {
      this.add_loading = true;
      this.$message({
        type: "info",
        duration: 0,
        offset: 7,
        showClose: true,
        dangerouslyUseHTMLString: true,
        message: 'リストにインフルエンサーを追加中です<div class="loader--mini"></div>',
      });
      var params = new URLSearchParams();
      params.append("list_id", id);
      params.append("influencer", JSON.stringify(this.checkList));
      params.append("sns_type", this.sns_type);
      params.append("add_comment", this.add_comment);
      params.append("from_media_search", this.from_media_search);
      params.append("token", this.token);
      this.axios.post(addInfluencerAPI, params).then(() => {
        this.$message.closeAll();
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: this.checkList.length + "名のインフルエンサーを" + name + "に追加しました",
        });
        this.$store.dispatch("loadSidemenuOption", this.token);
        this.loadList(); //このコンポーネントのリスト一覧を更新
        this.$emit("loadList"); //ListDetail サイドのリスト一覧を更新
        this.$emit("update:checkList", []);
        this.$emit("update:checkAll_val", false);
        this.add_loading = false;
        this.confirm = false;
      });
      this.add_loading = false;
      this.confirm = false;
    },
    openUnpermitted() {
      this.$store.dispatch("openUnpermittedDrawer", true);
    },
    focusOK() {
      document.getElementById("ok-button").focus();
    },
    addKeyDown() {
      document.addEventListener("keydown", this.onKeyDown);
    },
    removeKeyDown() {
      document.removeEventListener("keydown", this.onKeyDown);
    },
    onKeyDown(event) {
      if (event.key == "Escape") this.confirm = false;
    },
  },
  beforeDestroy() {
    this.removeKeyDown();
  },
  watch: {
    //mounted時にpermissionが読み込めないとloadListが実行されないため
    permission() {
      this.loadList();
    },
  },
};
</script>
